import React from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import UI_ACTIONS from '../../data/UiActionConstants.js';
import ListingComponent from '../../components/ListingComponent';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import UiAction from '../../components/UiAction.js';
import { useSelector, useDispatch } from "react-redux";
import {
  updateQueryParams,
  selectQueryParams
} from "../../ui/customerListingReducer";

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const [ deleteMappingApi ] = getApi('deleteUserAreaMapping')
  const dispatch = useDispatch();
  const selectedQueryParams = useSelector(selectQueryParams)

  const onDeleteClick = async (id) => {
    try{
      await deleteMappingApi({id: id}).unwrap();
      toast.success("User mapping removed from the area successfully.")
      dispatch(updateQueryParams(selectedQueryParams));
    } catch(error) {
      toast.error(error.data.message || "Something went wrong while fetching user details.")
    }
  }

  const params = useParams();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      value: (row) => {
        return <>
          <span className='mx-2'>
            {row.is_valid || row.is_valid == null ? <FontAwesomeIcon icon={faCircle} className="text-success"/> : <FontAwesomeIcon icon={faCircle} className="text-danger"/>}
          </span>
          {row.id}
        </>
      },
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Pincode - Area',
      value: (row) => `${row.area.code} - ${row.area.area}`
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
      disableSort: false
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.delete_area_user_mapping.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onDeleteClick(row.id) }>
              <FontAwesomeIcon icon={faTrash} className="text-danger"/>
            </div>
          </UiAction>
        </div>
      }
    }
  ];

  return <>
    <ListingComponent
      key={'PAGES.AreaUserMappingListingPage.name'}
      listingMutation={getApi('userPincodeMap')}
      className="area-user-mapping-listing"
      contentHeading="Area Pincode Mapping - Results"
      headers={headers}
      recordsKey="area_user_mappings"
      params={{id: params.id}}
      searchBy={['ID', 'Pincode', 'Area']}
    />
  </>
};

export default Listing;
